module.exports = __webpack_public_path__ + "static/media/coding-logo.cf365e41.svg";